import React, { FC, SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const SuccessBadgeIcon: FC<SVGComponentProps & SVGProps<SVGSVGElement>> = ({
  width = 40,
  height = 40,
  className = undefined,
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect width={40} height={40} rx={20} fill="#DCFCE7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10C19.209 10 18.45 10.314 17.89 10.874L16.997 11.767C16.8114 11.95 16.5617 12.0534 16.301 12.055H15.04C14.648 12.0549 14.2597 12.132 13.8975 12.282C13.5353 12.4319 13.2062 12.6518 12.929 12.929C12.6518 13.2062 12.4319 13.5353 12.2819 13.8975C12.132 14.2598 12.0549 14.648 12.055 15.04V16.302C12.0534 16.5627 11.95 16.8124 11.767 16.998L10.874 17.891C10.3144 18.4506 10 19.2096 10 20.001C10 20.7924 10.3144 21.5514 10.874 22.111L11.767 23.004C11.95 23.1896 12.0534 23.4393 12.055 23.7V24.962C12.055 25.7534 12.3694 26.5124 12.929 27.072C13.4886 27.6316 14.2476 27.946 15.039 27.946H16.301C16.562 27.946 16.813 28.05 16.997 28.234L17.89 29.127C18.4496 29.6866 19.2086 30.001 20 30.001C20.7914 30.001 21.5504 29.6866 22.11 29.127L23.003 28.234C23.1886 28.051 23.4383 27.9476 23.699 27.946H24.961C25.7524 27.946 26.5114 27.6316 27.071 27.072C27.6306 26.5124 27.945 25.7534 27.945 24.962V23.7C27.945 23.439 28.049 23.188 28.233 23.004L29.126 22.111C29.6856 21.5514 30 20.7924 30 20.001C30 19.2096 29.6856 18.4506 29.126 17.891L28.233 16.998C28.0499 16.8124 27.9466 16.5627 27.945 16.302V15.04C27.945 14.2486 27.6306 13.4896 27.071 12.93C26.5114 12.3704 25.7524 12.056 24.961 12.056H23.699C23.4383 12.0544 23.1886 11.951 23.003 11.768L22.11 10.875C21.8331 10.5976 21.5042 10.3775 21.1422 10.2273C20.7801 10.0772 20.392 9.99992 20 10ZM23.683 17.73C23.7807 17.6383 23.8589 17.5279 23.9131 17.4053C23.9672 17.2827 23.9962 17.1505 23.9983 17.0166C24.0004 16.8826 23.9755 16.7496 23.9252 16.6254C23.8749 16.5012 23.8001 16.3884 23.7053 16.2937C23.6105 16.199 23.4977 16.1243 23.3734 16.074C23.2492 16.0238 23.1162 15.999 22.9822 16.0012C22.8482 16.0033 22.716 16.0324 22.5935 16.0867C22.471 16.1409 22.3606 16.2193 22.269 16.317L18.016 20.57L16.739 19.293C16.5515 19.1054 16.2971 18.9999 16.0318 18.9998C15.7666 18.9997 15.5121 19.105 15.3245 19.2925C15.1368 19.48 15.0314 19.7344 15.0313 19.9996C15.0312 20.2649 15.1365 20.5194 15.324 20.707L17.309 22.691C17.4965 22.8785 17.7508 22.9838 18.016 22.9838C18.2812 22.9838 18.5355 22.8785 18.723 22.691L23.683 17.731V17.73Z"
        fill="#00A63E"
      />
    </svg>
  </SVGUniqueID>
);

export { SuccessBadgeIcon };
